import request from '@/utils/request'

// 分页查询
export function getList (data) {
  return request({
    url: `/msg/querySubordinateStudent`,
    method: 'post',
    data
  })

}

export function getListApi (data) {
  return request({
    url: `/schedule/queryDelScheduleList`,
    method: 'post',
    data
  })

}


export function getListApiSetInit (data) {
  return request({
    url: `/cancelCourseDiagram/queryScheduleDetail`,
    method: 'post',
    data
  })
}


export function getListApiSetInits (data) {
  return request({
    url: `/lossCourseDiagram/queryProductDetail`,
    method: 'post',
    data
  })
}

// 创建消息
export function ApiExhortNews (data) {
  return request({
    url: `/msg/creationMessage`,
    method: 'post',
    data
  })

}


// 获取聊天列表
export function ApiChatList (data) {
  return request({
    url: `/msg/getMessageByMsgId?msgId=` +  data.msgId,
    method: 'post',
    // data
  })

}



// 发送消息
export function ApiSendMessage (data) {
  return request({
    url: `/msgContext/sendMessage`,
    method: 'put',
    data
  })

}

// 撤回消息
export function ApiDeleteMessage (id) {
  return request({
    url: `/msgContext/deleteMessage?id=${id}`,
    method: 'delete',
  })

}


// 修改状态
export function ApiStatus (data) {
  return request({
    url: `/msg/changeMessage`,
    method: 'put',
    data
  })

}


//  跟进学员查询
export function ApigetStudentMsgList (data) {
  return request({
    url: `/teacher/getStudentMsgList`,
    method: 'post',
    data
  })
}

//  跟进科目
export function ApigetSubjectMsgList (data) {
  return request({
    url: `/teacher/getSubjectMsgList`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/weekendReminder.js